import { useMutation, useQueryClient } from '@tanstack/react-query'
import { CheckinsService } from '@/shared/api/rest/services/checkins.service'
import { useAlertService } from '@/shared/lib/useAlertService'
import { SERVICE_SESSION } from '@/modules/signup-page/types'

export const useClearStaleCheckouts = () => {
    const alertService = useAlertService()
    const queryClient = useQueryClient()

    const { mutateAsync, isPending } = useMutation({
        mutationFn: ({
            branchId,
            session
        }: {
            branchId: string
            session: SERVICE_SESSION | string
        }) => CheckinsService.clearStale(branchId, session),
        onSuccess: (data) => {
            const count = data?.updated ?? data?.cleared ?? 0
            alertService.success(
                `Successfully cleared ${count} stale checkout${count !== 1 ? 's' : ''}`
            )
            queryClient.invalidateQueries({ queryKey: ['stale-checkouts'] })
        },
        onError: (error: Error) => {
            alertService.error(error.message)
        }
    })

    const handleClearStaleCheckouts = async (
        branchId: string,
        session: SERVICE_SESSION | string
    ) => {
        if (!branchId || !session) return
        await mutateAsync({ branchId, session })
    }

    return {
        clearStaleCheckouts: handleClearStaleCheckouts,
        clearing: isPending
    }
}
